import type { Props } from './GuidingText'
import GuidingText from './GuidingText'

const GuidingTextPerFlag = (props: Props) => {
  return <GuidingText {...props} />
}

export default GuidingTextPerFlag
